export const types = ["IPv4", "IPv6", "Mobile", "Residential", "ISP"];
